import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import * as _ from "lodash";
// import moment from "moment";
import useReactRouter from "use-react-router";

//apollo
import { CREATE_INVOICE } from "../../graphql/invoice/mutation";

import { Table, Form, Row, Col, Button, Card, Badge, Spinner } from "react-bootstrap";
// import { GET_ORDERGROUPS } from "../../graphql/order/query";
import { convertCurrency, convertCurrentDate, NewCovertTimeZone, numberFormat, startDateAndEndDate } from "../../helpers";
// import {
//   convertOrderStatus,
//   convertOrderType,
// } from "../../helpers/orderStatus";
import { warningMessage } from "../../constants/SweetAlertConst";
import { errorTitleWithTextSwal } from "../../helpers/sweetalert";
import PaginationsV1 from "../../components/PaginationV1";
// import { UPDATE_MANY_ORDERGROUPS } from "../../graphql/order/mutation";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import Swal from "sweetalert2";
import LoadingSpinner from "../../components/LoadingSpinner";
// import { FaEye } from "react-icons/fa";
import OrderDetailModal from "./components/OrderDetailModal";
import { GET_SHOP_COMMISION_INFLUENCER } from "../../graphql/influencer/query";
// import { calculateReportInfluencer } from "../../helpers/calculationReport";
import { MdOutlineDateRange } from "react-icons/md";
import CurrentDateModal from "../../components/currentComponent/CurrentDateModal";
import { GET_STOCKS_ORDER_REPORT } from "../../graphql/stock/query";

function ReportStockSalePage() {
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const selectRef = useRef(null);

  //state for set values
  // set time default in this week
  const [filter, setFilter] = useState({
    createdAt_gte: startDateAndEndDate("week", "YYYY-MM-DD").startMonth,
    createdAt_lt: startDateAndEndDate("week", "YYYY-MM-DD").endMonth,
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisWeek");
  const [orderLists, setOrderLists] = useState([]);
  const [orderListsTotal, setOrderListsTotal] = useState(0);
  const [summaryStock, setSummaryStock] = useState(0);
  const [summaryMoney, setSummaryMoney] = useState({
    kip: 0,
    bath: 0,
    usd: 0,
  });
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [reportData, setReportData] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = React.useState(false);
  // const [showUpdateStatus, setShowUpdateStatus] = React.useState(false);
  const [selectedInfluencer, setSelectedInfluencer] = useState();

  const handleCloseRemoveProduct = () => setShowConfirmRemove(false);

  const [createInvoice, { loading: createLoading }] = useMutation(CREATE_INVOICE);

  const [
    getReportStockOrder,
    { data: reportStockOrderData, loading: reportStockOrderLoading },
  ] = useLazyQuery(GET_STOCKS_ORDER_REPORT, {
    fetchPolicy: "network-only",
  });

  const { data: commisionInfluencer } = useQuery(GET_SHOP_COMMISION_INFLUENCER, {
    fetchPolicy: "cache-and-network",
    variables: {
      where: {
        shop: shop?.id,
      },
      orderBy: "createdAt_DESC",
      limit: 100,
      skip: 0,
    },
  });

  const rowsPerPage = 30;
  const [page, setPage] = useState(0);
  const pageAll =
    orderListsTotal > 0 ? Math.ceil(orderListsTotal / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  //useEffect for fetch data
  useEffect(() => {
    fetchReportStockOrder();
  }, [
    shop?.id,
    filter?.searchText,
    filter?.getType,
    filter?.createdAt_gte,
    filter?.createdAt_lt,
    page,
    selectedInfluencer
  ]);

  useEffect(() => {
    if (reportStockOrderData?.reportStockOrder) {
      const data = reportStockOrderData?.reportStockOrder?.dataMany;
      setOrderLists(data);
      setOrderListsTotal(reportStockOrderData?.reportStockOrder?.total);
      setSummaryStock(data.reduce((acc, order) => acc + order.amount, 0));
      setSummaryMoney(data.reduce((acc, order) => {
        // check currency
        if (["KIP", "LAK", "", "ກີບ", undefined, null].includes(order.currency)) {
          acc.kip += parseInt(order.price) * order.amount;
        } else if (["BATH", "THB", "ບາດ"].includes(order.currency)) {
          acc.bath += parseInt(order.price) * order.amount;
        } else if (["USD", "ໂດລາ"].includes(order.currency)) {
          acc.usd += parseInt(order.price) * order.amount;
        }
        return acc;
      }, { kip: 0, bath: 0, usd: 0 }));
    }
  }, [reportStockOrderData?.reportStockOrder]);

  // get ordergroups data
  const fetchReportStockOrder = async () => {
    try {
      if (reportStockOrderLoading) return;
      let _where = {
        shop: shop?.id,
        isDeleted: false,
        type: "SALE_PAGE",
        status: "COMPLETED",
      }
      if (!_.isEmpty(filter?.searchText)) {
        _where = {
          ..._where,
          code: filter?.searchText,
        };
      }
      if (!_.isEmpty(filter?.getType)) {
        _where = {
          ..._where,
          typeForAffiliate: filter?.getType,
        }
      }
      if (!_.isEmpty(selectedInfluencer)) {
        _where = {
          ..._where,
          infulancer: selectedInfluencer?.id,
        }
      }

      if (
        filter?.createdAt_gte !== "" &&
        filter?.createdAt_lt !== ""
      ) {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(filter?.createdAt_gte, "YYYY-MM-DD"),
          createdAt_lt: NewCovertTimeZone(filter?.createdAt_lt, "YYYY-MM-DD")
        };
      }

      await getReportStockOrder({
        variables: {
          where: _where,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
        },
      });

    } catch (error) {
      console.log("error--->", error);
    }
  };

  //function create invoice
  const handleCreateInvoice = async () => {
    if (createLoading) return;

    //validate check data before create invoice
    if (selectedOrders.length <= 0)
      return warningMessage("ກະລຸນາເລືອກລາຍການກ່ອນ !");
    //calulate total money before send api
    const totalKip = selectedOrders.reduce(
      (acc, order) => acc + order.totalPrice,
      0
    );

    const totalBathPlusUsd = selectedOrders.reduce((acc, order) => {
      if (order.sumPriceBaht !== 0) {
        acc += order.sumPriceBaht * order.exchangeRate?.baht;
      }
      if (order.sumPriceUsd !== 0) {
        acc += order.sumPriceUsd * order.exchangeRate?.usd;
      }
      return acc;
    }, 0);

    let totalMoney = totalKip + totalBathPlusUsd;

    //get id order
    const orderId = selectedOrders.map((order) => order.id);

    //prepare data before update
    let _data = {
      totalMoney: totalMoney,
      status: "REQUEST",
      percent: 3,
      orderGroups: orderId,
      shop: shop?.id,
      shopName: shop?.name,
    };
    //try create invoice
    try {
      const result = await createInvoice({
        variables: {
          data: _data,
        },
      });

      if (result?.data?.createInvoices?.id) {
        setShowConfirmRemove(false);
        Swal.fire({
          title: "ສຳເລັດ",
          text: "ສ້າງໃບຖອນເງິນສຳເລັດ",
          icon: "success",
          showConfirmButton: false,
          timer: 1800,
        }).then((values) => {
          // fetchReportStockOrder();
          setSelectedOrders([]);
          setSelectAll(false);
        });
      }
    } catch (err) {
      console.log("error--->", err);
      errorTitleWithTextSwal({
        title: "ບໍ່ສາມາດສ້າງໃບຖອນເງິນໄດ້",
        text: "ກະລຸນາຕິດຕໍ່ຜູ້ໃຫ້ບໍລິການ",
      });
    }
  };

  // Create a debounced search function
  const debouncedSearch = useCallback(
    _.debounce((text) => {
      setFilter(prev => ({ ...prev, searchText: text }));
    }, 500),
    []
  );

  const summaryStyle = { fontSize: 16, fontWeight: 'bold', color: "green" };

  return (
    <>
      <div>
        <div style={{ padding: "0 9px" }}>

          <Row className="g-3">
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ຄົ້ນຫາ</Form.Label>
                <Form.Control
                  onChange={(e) => {
                    debouncedSearch(e.target.value);
                  }}
                  value={filter?.searchText}
                  type="text"
                  placeholder="ປ້ອນເລກໃບສັ່ງຊື້ ຫຼື ຊື່ລູກຄ້າ..."
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>ຊ່ອງທາງອໍເດີ້</Form.Label>
                    <Form.Select
                      onChange={(e) => {
                        setFilter({ ...filter, getType: e.target.value });
                      }}>
                      <option value="ORDER_NOMAL">ອໍເດີ້ຂອງຮ້ານ</option>
                      <option value="ORDER_AFFILIATE">ອໍເດີ້ຂອງ ອາຟຣິລີເອດ</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>ລາຍຊື່ອິນຟູ</Form.Label>
                    <Form.Select
                      disabled={filter?.getType === "ORDER_AFFILIATE" ? false : true}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const influencer = commisionInfluencer?.shopSettingCommissionInfulancers?.data.find(
                          item => item.infulancer.id === selectedId
                        );
                        setSelectedInfluencer(influencer?.infulancer || null);
                        setFilter({ ...filter, influencerId: selectedId });
                      }}>
                      <option value="">ເລືອກອິນຟູ</option>
                      {commisionInfluencer?.shopSettingCommissionInfulancers?.data?.map((item, index) => (
                        <option key={index} value={item?.infulancer?.id}>
                          {item?.infulancer?.first_name} {item?.infulancer?.last_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ວັນທີ່</Form.Label>
                <Button
                  variant="outline-secondary"
                  onClick={() => setIsCurrentModals(true)}
                  style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
                >
                  {(reportStockOrderLoading) ? (
                    <Spinner size="sm" />
                  ) : (
                    <MdOutlineDateRange style={{ fontSize: 24 }} />
                  )}
                  &nbsp;  &nbsp;
                  {(filter?.createdAt_gte === "" && filter?.createdAt_lt === "") ? (
                    <span style={{ fontSize: 14 }}>ຄົ້ນຫາຕາມວັນທີ່...</span>
                  ) : (
                    <span style={{ fontSize: 14 }}>
                      {convertCurrentDate(filter?.createdAt_gte) +
                        " - " +
                        convertCurrentDate(filter?.createdAt_lt)}
                    </span>
                  )}
                </Button>
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px", marginBottom: "5px" }}>
            <Col>
              {/* card info influencer  */}
              <Card style={{ boxShadow: "none" }}>
                <Card.Header>ຂໍ້ມູນ ອາຟຣີລີແອດ</Card.Header>
                <Card.Body>
                  {selectedInfluencer ? (
                    <>
                      <Card.Title>ຊື່: {selectedInfluencer.first_name} {selectedInfluencer.last_name}</Card.Title>
                      <Card.Text>
                        <h6>ເບີໂທ: {selectedInfluencer.phone || '-'}</h6>
                        <h6>ທີ່ຢູ່: {selectedInfluencer.village_name || '-'}, {selectedInfluencer.district_name || '-'}, {selectedInfluencer.province_name || '-'} </h6>
                        {/* <h6>ຄ່າຄອມ: {selectedInfluencer.commission_rate || '-'}%</h6> */}
                      </Card.Text>
                    </>
                  ) : (
                    <Card.Text>ກະລຸນາເລືອກອິນຟູເພື່ອເບິ່ງຂໍ້ມູນ</Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ boxShadow: "none" }}>
                <Card.Header>ສະຫຼຸບຍອດ</Card.Header>
                <Card.Body>
                  <Card.Text>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຈຳນວນລາຍການສີນຄ້າ:</span> <span style={summaryStyle}>{orderListsTotal || 0} ທັງຫທົດ</span> </h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດສີນຄ້າ:</span> <span style={summaryStyle}>{summaryStock || 0} ທັງຫທົດ</span> </h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດເງິນ:</span> <span style={summaryStyle}>{numberFormat(summaryMoney?.kip || 0)} {convertCurrency("LAK")}</span></h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດເງິນ:</span> <span style={summaryStyle}>{numberFormat(summaryMoney?.bath || 0)} {convertCurrency("BAHT")}</span></h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດເງິນ:</span> <span style={summaryStyle}>{numberFormat(summaryMoney?.usd || 0)} {convertCurrency("USD")}</span></h5>
                    <div />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* show list invoice */}
          <ListStockSalePage
            orderLists={orderLists}
            createLoading={createLoading}
            orderListsTotal={orderListsTotal}
            reportStockOrderLoading={reportStockOrderLoading}
            selectRef={selectRef}
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            rowsPerPage={rowsPerPage}
            page={page}
          />
          {/* show list invoice */}
          {orderLists?.length > 0 ? (
            <PaginationsV1
              count={orderListsTotal}
              rowsPerPage={rowsPerPage}
              page={page}
              pageAll={pageAll}
            onPageChange={handleChangePage}
          />
          ) : (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "120px", // or any height that fits your layout
              width: "100%",
            }}>
              <p style={{
                color: "gray",
                fontWeight: "bold",
                margin: 0,
                textAlign: "center"
              }}>
                !ບໍ່ພົບຂໍ້ມູນ
              </p>
            </div>
          )}
        </div>
      </div>

      <ModalConfirmComponent
        showConfirmModal={showConfirmRemove}
        handleCancel={handleCloseRemoveProduct}
        loadingConfirm={createLoading}
        handleConfirm={handleCreateInvoice}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການສ້າງອິນວອຍ (invoice) ນີ້ແທ້ບໍ?"
      />

      {/* modal current date  */}
      <CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}
      />

    </>
  );
}

export default ReportStockSalePage;

const statusWait = () => {
  return <div style={{ color: "gray", fontSize: ".8em" }}>ຍັງບໍ່ທັນແຈ້ງຖອນ</div>;
};

const statusRequest = () => {
  return <div style={{ color: "orange", fontSize: ".8em" }}>ແຈ້ງຖອນແລ້ວ</div>;
};

const statusReject = () => {
  return <div style={{ color: "red", fontSize: ".8em" }}>ຖືກປະຕິເສດ</div>;
};

const statusApproved = () => {
  return <div style={{ color: "green", fontSize: ".8em" }}>ຢືນຢັນການຖອນແລ້ວ</div>;
};

const viewsStatus = {
  WAITING: statusWait,
  REQUEST: statusRequest,
  REJECT: statusReject,
  APPROVED: statusApproved,
};

const ListStockSalePage = ({
  orderLists,
  orderListsTotal,
  reportStockOrderLoading,
  selectRef,
  selectedOrders,
  setSelectedOrders,
  selectAll,
  setSelectAll,
  createLoading,
  rowsPerPage,
  page,
}) => {
  const { history } = useReactRouter();
  const [orderObj, setOrderObj] = useState({
    open: false,
    datas: null,
  })

  //select all
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
    } else {

      const getOrder = orderLists.filter(
        (order) =>
          order.invoiceStatus === "WAITING" || order.invoiceStatus === "REJECT"
      );

      setSelectedOrders(getOrder);
    }
    setSelectAll(!selectAll);
  };

  // select order
  const handleSelect = (order) => {
    // console.log("orderSelect9---->", order);

    if (selectedOrders.some((item) => item.id === order.id)) {
      setSelectedOrders(selectedOrders.filter((item) => item.id !== order.id));
    } else {
      // Add the object to the array as well
      setSelectedOrders([...selectedOrders, order]);
    }
  };

  const tableItemStyle = {
    borderRadius: ".3em",
    fontSize: ".8em",
  }

  const tableItemOrderStyle = {
    borderRadius: ".2em",
    fontSize: ".6em",
  }

  //checkStatus
  const checkStatus = (status) => {
    const CurrenctStatus = viewsStatus[status];
    return <CurrenctStatus />;
  };

  const _gotoOrderGroupDetail = (orderId, order) => {
    history.push(`/orders-add`, { editMode: true, orderGroup: order });
  };

  if (reportStockOrderLoading || createLoading)
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <LoadingSpinner />
      </div>
    );

  return (
    <React.Fragment>

      <Table responsive>
        <thead>
          <tr style={{ whiteSpace: "nowrap" }}>
            <td style={{ borderBottom: "1px solid #eeeeee" }}>
              ລຳດັບ
            </td>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ຊື້ສິນຄ້າ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ປະເພດສີນຄ້າ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ຈຳນວນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລາຄາຕົ້ນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລາຄາຂາຍ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລວມເງີນຕົ້ນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລວມເງີນຂາຍ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ສະກຸນເງີນ</th>
          </tr>
        </thead>
        <tbody>
          {orderLists?.map((item, index) => (
            <tr key={item?.id}>
              <td>
                {page * rowsPerPage + index + 1}
              </td>
              <td style={{ fontWeight: "bold", fontSize: "1em"}}>
                {item?.name || '-'}
                {/* <Badge bg="info">{item?.name || '-'}</Badge> */}
              </td>
              <td>
                <Badge bg="secondary">{item?.categoryName ?? "-"}</Badge>
              </td>
              <td style={{ fontWeight: "bold", fontSize: "1em"}}>
                {/* <Badge bg="success"> */}
                {item?.amount}
                {/* </Badge>  */}
              </td>
              <td style={{ fontWeight: "bold" }}>
                <Badge bg="secondary">
                {item?.originPrice}
                </Badge> 
              </td>
              <td style={{ fontWeight: "bold" }}>
                <Badge bg="secondary">
                {item?.price}
                </Badge> 
              </td>
              <td style={{ fontWeight: "bold" }}>
                <Badge bg="secondary">
                {parseInt(item?.originPrice) * parseInt(item?.amount)}
                </Badge> 
              </td>
              <td style={{ fontWeight: "bold" }}>
                <Badge bg="secondary">
                {parseInt(item?.price) * parseInt(item?.amount)}
                </Badge> 
              </td>
              <td>
                <Badge bg="success">{convertCurrency(item?.currency)}</Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <OrderDetailModal datas={orderObj.datas} open={orderObj.open} handleClose={() => setOrderObj({ open: false, datas: null })} />
    </React.Fragment>
  );
};

